import React, { Component } from "react";
import HdfcHeader from "../../common/components/pageBlocks/hdfcHeader";
import successCar from "../../assets/images/animations/Succes.json";
import errorCar from "../../assets/images/animations/Error.json";
import commonContext, { AppContext } from "../../common/context/common";
import FormStep from "../../common/components/formStep";
import LottieAnimation from "../../common/components/lottieAnimation";
import { leadType } from "../../app";
import { alertIcon } from "../../common/utils/images";

interface IProps {
    history?: any;
}
interface IState {
    status: boolean;
    applicationNumber: string;
    carModel: string;
}
class ConfirmationSection extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    setLead: Function;
    base: any;
    steps = [
        { title: "Vehicle" },
        { title: "Loan" },
        { title: "Personal" },
        { title: "e-Mandate" },
    ];
    constructor(props: IProps) {
        super(props);
        this.state = {
            status: true,
            applicationNumber: "",
            carModel: "",
        };
    }
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.setLead = (this.context as AppContext).setLead;
        this.lead = (this.context as AppContext).lead as leadType;
    }
    render() {
        const { lead, base } = this.context;
        this.lead = (this.context as AppContext).lead as leadType;
        this.base = (this.context as AppContext).base;
        return (
            <>
                <div className="wrapper">
                    <HdfcHeader />
                    <section className="confirm-wrap mt-110">
                        <div className="container mx-auto px-5">
                            <FormStep
                                steps={[
                                    ...this.steps,
                                    {
                                        title: "Confirmation",
                                        active: true,
                                        failed: !lead.confirmStatus,
                                    },
                                ]}
                            />

                            <div className="congrats-screen w-full">
                                <div className="flex justify-center mx-auto car-img-wrap mb-3 md:mb-6">
                                    <LottieAnimation
                                        width={230}
                                        height={180}
                                        animationData={
                                            lead.confirmStatus
                                                ? successCar
                                                : errorCar
                                        }
                                    />
                                </div>

                                <h1 className="text-center text-gray-2 font-42px openSans-Light mt-3 w-10/12 mx-auto">
                                    {lead.confirmStatus ? (
                                        <>
                                            <h1 className="text-center text-gray-2 font-42px openSans-Light mt-3 w-10/12 mx-auto leading-snug">
                                                Thank you <br />
                                                for accepting the loan documents
                                            </h1>
                                            <h2 className="text-center text-gray-2 text-2xl openSans-Light mt-3 w-10/12 mx-auto leading-snug">
                                                Your loan number is{" "}
                                                <span className="openSans-SemiBold">
                                                    {
                                                        this.lead
                                                            .uniqueReferenceNo
                                                    }
                                                </span>
                                            </h2>
                                            <div className="text-center mt-4 mb-4">
                                                <p className="openSans-Reg congrats-screen-txt text-center text-xs md:text-base lg:text-lg my-4">
                                                    Congratulations! Your Auto
                                                    Loan will be disbursed
                                                    shortly. After deduction of
                                                    applicable charges, the net
                                                    amount of{" "}
                                                    <span className="openSans-SemiBold">
                                                        <span className="WebRupee">
                                                            Rs.
                                                        </span>
                                                        {this.lead.totalAmount}
                                                        /-{" "}
                                                    </span>
                                                    will be credited to dealer's
                                                    account
                                                </p>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            {" "}
                                            <h1 className="text-center text-gray-2 font-42px openSans-Light mt-3 w-10/12 mx-auto leading-snug">
                                                There seems to be an issue
                                            </h1>
                                            <h2 className="text-center text-gray-2 text-2xl openSans-Light mt-3 w-10/12 mx-auto leading-snug">
                                                with your loan application{" "}
                                                <span className="openSans-SemiBold">
                                                    {
                                                        this.lead
                                                            .uniqueReferenceNo
                                                    }{" "}
                                                </span>
                                                for{" "}
                                                <span className="openSans-SemiBold">
                                                    {this.lead.manufacturer}{" "}
                                                    {this.lead.make}{" "}
                                                    {this.lead.model}
                                                </span>
                                            </h2>
                                        </>
                                    )}
                                </h1>

                                {!lead.confirmStatus ? (
                                    <>
                                        <div className="flex items-first md:items-center justify-center my-8 py-2 px-2 rounded-md text-track light-red w-11/12 md:w-8/12 mx-auto text-sm">
                                            <span className="mr-3 icon-minw">
                                                <img
                                                    className="object-cover"
                                                    src={alertIcon}
                                                    alt="Alert icon"
                                                    title="Alert icon"
                                                />
                                            </span>
                                            Lorem ipsum dolor sit amet,
                                            consectetur ading elit, sed do
                                            eiusmod tempor incididunt ut labore
                                            et magna aliqua.
                                        </div>
                                        <p className="openSans-Light text-center text-base sm:text-xl md:text-2xl">
                                            Contact your nearest branch for more
                                            details
                                        </p>
                                        <div className="w-full my-8 mx-auto text-center">
                                            <button
                                                onClick={() =>
                                                    this.props.history.push(
                                                        "offer"
                                                    )
                                                }
                                                className="bg-transparent border-2 button-blue-border blue-link-color hover:text-white  py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue button-white-blue openSans-SemiBold mb-2 transition-all"
                                            >
                                                Restart Loan Application
                                            </button>
                                        </div>
                                    </>
                                ) : (
                                    ""
                                )}
                            </div>
                        </div>
                    </section>
                </div>
            </>
        );
    }
}

export default ConfirmationSection;
